export default __webpack_public_path__ + "static/media/image.cemex-hrm.01b81d2f.png";